import elevation from '@/theme/elevation';
import {sizePx} from '@/theme/helpers/size';
import Link from 'next/link';
import styled from 'styled-components';
import focus from '@/theme/focus';

export const StyledAdCard = styled(Link)`
  display: inline-block;
  border-radius: ${sizePx(2)};
  cursor: pointer;
  overflow: hidden;
  width: ${sizePx(150)};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.14);
    }
  }

  &:active {
    ${elevation.Highlight}
  }

  ${focus.brand(elevation.value('Highlight'))}
`;
